export const internshipData = [{
    "title": "Research Engineer Intern @ IMDA BizTech Group",
    "content": `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quis sapiente 
    laborum cupiditate possimus labore, hic temporibus velit dicta earum
    suscipit commodi eum enim atque at? Et perspiciatis dolore iure
    voluptatem.`,
    "link": ""
}, {
    "title": "Software Developer (Backend) @ IMDA Digital Services Lab",
    "content": `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quis sapiente 
    laborum cupiditate possimus labore, hic temporibus velit dicta earum
    suscipit commodi eum enim atque at? Et perspiciatis dolore iure
    voluptatem.`,
    "link": ""
}, {
    "title": "Software Developer @ Boxgreen Singapore",
    "content": `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quis sapiente 
    laborum cupiditate possimus labore, hic temporibus velit dicta earum
    suscipit commodi eum enim atque at? Et perspiciatis dolore iure
    voluptatem.`,
    "link": ""
}]